import axios from 'axios';

axios.interceptors.request.use(
  config => {
    try {
      const authStr = localStorage.getItem('auth');
      if (authStr) {
        const authData = JSON.parse(authStr);
        const token = authData.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          console.log('Токен добавлен к запросу:', config.url);
        }
      }
    } catch (e) {
      console.error('Ошибка авторизации:', e);
    }
    return config;
  },
  error => Promise.reject(error)
);

export default axios;